import PropTypes from "prop-types";

const ButtonOne = ({
  children,
  className = "",
  onClick,
  type = "button",
  position = "",

  bgColor = "#2FC1E2",
  textColor = "#FFFFFF",
  fontSize = "1.5rem",
  paddingX = "3.5rem",
  paddingY = "1rem",
  borderRadius = "1.5rem",

  style = {},
}) => {
  const baseClasses = "font-bold transition-colors";

  const buttonStyle = {
    backgroundColor: bgColor,
    color: textColor,
    fontSize,
    paddingLeft: paddingX,
    paddingRight: paddingX,
    paddingTop: paddingY,
    paddingBottom: paddingY,
    borderRadius,
    ...style,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      style={buttonStyle}
      className={`${position} ${baseClasses} ${className}`.trim()}
    >
      {children}
    </button>
  );
};

ButtonOne.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  position: PropTypes.string,

  bgColor: PropTypes.string,
  textColor: PropTypes.string,
  fontSize: PropTypes.string,
  paddingX: PropTypes.string,
  paddingY: PropTypes.string,
  borderRadius: PropTypes.string,

  style: PropTypes.object,
};

export default ButtonOne;